const STORAGE_KEY = "sc-cost-swr-cache";
// Only persist entries for cost-and-usage API calls.
const COST_URL_FRAGMENT = "/api/cost-and-usage/";
const CACHE_DURATION_MS = 7_200_000; // 2 hours

interface PersistedEntry {
  state: unknown;
  timestamp: number;
}

// SWR (stale-while-revalidate) cache provider that persists CUS responses to localStorage.
// On init, restores non-expired entries into the SWR cache Map so hooks return cached data
// On page unload, writes only cost-and-usage entries back to localStorage with a timestamp.
// Entries older than CACHE_DURATION_MS are dropped on restore.
export function costLocalStorageProvider(): Map<string, any> {
  let initialEntries: [string, any][] = [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed: [string, PersistedEntry][] = JSON.parse(raw);
      const now = Date.now();
      initialEntries = parsed
        .filter(
          ([key, entry]) =>
            key.includes(COST_URL_FRAGMENT) && now - entry.timestamp < CACHE_DURATION_MS
        )
        .map(([key, entry]) => [key, entry.state]);
    }
  } catch {
    // Ignore corrupt or missing localStorage data.
  }

  const map = new Map<string, any>(initialEntries);

  window.addEventListener("beforeunload", () => {
    try {
      const now = Date.now();
      const toSave: [string, PersistedEntry][] = [...map.entries()]
        .filter(([key]) => key.includes(COST_URL_FRAGMENT))
        .map(([key, state]) => [key, { state, timestamp: now }]);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
    } catch {
      // Ignore storage write errors (e.g. quota exceeded).
    }
  });

  return map;
}
